import { ref, watch, nextTick } from 'vue';
import { useCommonData } from '@/hooks';

export function useBannerImage() {
	const bannerRef = ref(null);
	const { getBackgroundImage } = useCommonData();

	const createImg = val => {
		const ref = bannerRef.value;
		const refC = ref?.child;
		if (refC && typeof refC.create === 'function') {
			refC.create(val);
		}
	};
	const addBannerListener = () => {
		watch(
			() => getBackgroundImage.value,
			val => {
				createImg(val);
			},
			{ immediate: true }
		);
	};
	const initBannerImage = () => {
		nextTick(() => {
			addBannerListener();
		});
	};

	return {
		bannerRef,
		initBannerImage
	};
}
